import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { removeTokenFromCookies } from '../utils';

export const useLogout = () => {
  const navigate = useNavigate();
  const logout = () => {
    removeTokenFromCookies()
    navigate(0); // Reload App
  };
  return logout;
};
